import { type ReactNode } from 'react';
import { Toaster } from '@/components/ui';
import { QueryProvider } from './query';
import { ThemeProvider } from './theme';

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryProvider>
      <ThemeProvider>
        {children}
        <Toaster />
      </ThemeProvider>
    </QueryProvider>
  );
}
